export const environment = {
    production: false,
    serverUrl: 'https://my5cabubpg.execute-api.us-east-2.amazonaws.com/dev',
    bucket: 'kcasenterprise-validation-upload',
    userPool: {
      UserPoolId: 'us-east-2_UVu2A049W',
      ClientId: '6bf6pcbubig1ldam0usuusadek',
      region: 'us-east-2'
    },
    identityPoolId: 'us-east-2:7df2a32d-4971-4cfe-9be0-04760c46e399',
    buckets: {
      'us-east-2': 'kcasenterprise-validation-upload'
    },
    modules: {
      key: 'analysisType',
      values: [
          {
            'name': 'qPCR',
            'desc': 'qPCR'
          },
          {
            'name': 'AP',
            'desc': 'A&P Regression'
          }
      ]
  },
    version: 'version 2.0',
    defaultRegion: 'us-east-2',
    cognito: {
      identityPoolId: 'us-east-2:7df2a32d-4971-4cfe-9be0-04760c46e399', // REQUIRED - Amazon Cognito Identity Pool ID
      region: 'us-east-2', // REQUIRED - Amazon Cognito Region
      userPoolId: 'us-east-2_UVu2A049W', // OPTIONAL - Amazon Cognito User Pool ID
      userPoolWebClientId: '6bf6pcbubig1ldam0usuusadek', // OPTIONAL - Amazon Cognito Web Client ID
    },
    Storage: {
      AWSS3: {
        bucket: 'kcasenterprise-validation-upload',
        region: 'us-east-2', // OPTIONAL -  Amazon service region
      }
    }
  };
  const awsconfig = {
    'aws_project_region': 'us-east-2',
    'aws_cognito_region': 'us-east-2',
    'aws_user_pools_id': 'us-east-2_UVu2A049W',
    'aws_user_pools_web_client_id': '6bf6pcbubig1ldam0usuusadek',
    'aws_cognito_mfa_configuration': 'OPTIONAL',

  };
  export default awsconfig;